
    <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="my-modal__body">
      <h2 class="title">Create New Poll {{_isCategoryBased ? "On Category" : ""}}</h2>
      <!-- <form (submit)="storePoll()"> -->
        <div class="form-group">
          <label for="" class="mb-0">Title</label>
          <input ngRequr type="text" [(ngModel)]="poll.name" [ngModelOptions]="{ standalone: true }"
            class="form-control" />
        </div>
        <div class="row">
          <div class="form-group col-sm-6">
            <label for="" class="mb-0">Start Date</label>
            <input ngRequr type="date" [(ngModel)]="poll.startDate" [ngModelOptions]="{ standalone: true }"
              class="form-control" />
          </div>
          <div class="form-group col-sm-6">
            <label for="" class="mb-0">End Date</label>
            <input ngRequr type="date" [(ngModel)]="poll.endDate" [min]="poll.startDate"
              [ngModelOptions]="{ standalone: true }" class="form-control" />
          </div>
        </div>
        <app-multi-dropdown [placeholder]="selectedCategory?.categoryName ?? 'Select Category'" *ngIf="_isCategoryBased"
         [items]="categoryList" (itemSelected)="onCategoryChange($event)" style="width: 300px;"></app-multi-dropdown>

        <input type="text" [(ngModel)]="poll.industryStandard"  class="form-control my-2" placeholder="Industry Standard" />

        <textarea placeholder="Open Ended Questions" class="form-control my-2" [(ngModel)]="poll.openEndedQuestion" *ngIf="_isCategoryBased"></textarea>
        <ng-container *ngIf="!_isCategoryBased">
          <button class="my-button-3 secondary mb-3" type="button" (click)="addPollsChild()"><i
              class="fa-solid fa-plus"></i> Add Poll</button>
          <div class="form-group" *ngFor="let row of poll.polls; let i = index">
            <label for="">Polling {{ i + 1 }}</label>
            <div class="d-flex">
              <input ngRequr type="text" [(ngModel)]="row.name" placeholder="Title for Polling {{ i + 1 }}"
                [ngModelOptions]="{ standalone: true }" class="form-control" />
              <button type="button" class="btn btn-danger btn-sm ml-2" (click)="removePollsChild(i)">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
        </ng-container>
        <div class="modal-footer px-0 pb-0">
          <button type="button" class="my-button-3 error" 
            (click)="modal.dismiss()"><i class="fa-solid fa-times"></i> Cancel</button>
          <button (click)="storePoll()" class="my-button-3" type="submit" ><i class="fa-solid fa-paper-plane"></i>
            Submit</button>
        </div>
      <!-- </form> -->
    </div>
